import PlanCard from './PlanCard';

export default PlanCard;
